const defaultParams = {
  maxWidth: 2000,
  maxHeight: 2000,
  quality: 0.8,
};

export default function compressor(base64, callParams = {}) {
  const canvas = document.createElement("canvas");
  const img = document.createElement("img");

  const { maxWidth, maxHeight, quality } = Object.assign(
    defaultParams,
    callParams
  );

  return new Promise((resolve, reject) => {
    img.onload = function () {
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height *= maxWidth / width));
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width *= maxHeight / height));
          height = maxHeight;
        }
      }
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      //resolve(base64);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = function (err) {
      reject(err);
    };
    img.src = base64;
  });
}
